import React from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { CHALLENGE } from 'constants/index';
import { challengeSelector } from 'reducers/challenge.reducer';
import DetailsChallengeDefault from './DetailsChallengeDefault';
import DetailsChallengeList from './DetailsChallengeList';
import DetailsChallengePhoto from './DetailsChallengePhoto';

export const DetailsPage = () => {
  const { id: challengeIdString }: { id: string } = useParams();
  const challengeId = Number(challengeIdString);
  const { data } = useSelector(challengeSelector(challengeId)) || {};
  const { type: challengeType } = data || { type: CHALLENGE.CLASSIC };
  // by default, consider the challenge to be a classic so it can display skeleton

  switch (challengeType) {
    case CHALLENGE.PHOTO:
      return <DetailsChallengePhoto challengeId={challengeId} />;
    case CHALLENGE.LIST:
      return <DetailsChallengeList challengeId={challengeId} />;
    default:
      return <DetailsChallengeDefault challengeId={challengeId} />;
  }
};
